export default __webpack_public_path__ + "static/media/refresh-cw-alert.3e61097c.svg";